import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setErrorMessage, setSuccessMessage } from '../redux/slices/MessageSlice';


const Message = () => {
    const dispatch=useDispatch();
    const {success,error}=useSelector((state)=>state.MessageReducer);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        let timer;
        if (success||error) { 
          if(error){
            dispatch(setSuccessMessage('')); 
            setTimeout(() => {
              dispatch(setErrorMessage(''))
            }, 2000); // 5 seconds
          }
          else{
            dispatch(setErrorMessage(''))
            setTimeout(() => {
              dispatch(setSuccessMessage('')); 
            }, 2000);
          }
        setProgress(0);  
      
          timer = setInterval(() => {
            setProgress((prevProgress) => prevProgress + 1);
          }, 10); // Update progress every 10 ms
        }
        return () => clearInterval(timer);
      }, [success,error]);
    
  

      if(success||error){
        return(
            <div className='fixed-top'>

                <div style={{ position:'absolute'
                ,top:'10px',
                left:'10px',
                zIndex:'10000000000000',
                backgroundColor:success?'#25d366':'#dc3545',
                width:'250px',
                borderRadius:'5px',
               
                }}>
                <div style={{
                padding:'8px',
                color:'white',
                display:'flex',
                justifyContent:'center',
                justifyContent:'flex-start',
                alignItems:'center',
                }}
                >
                    <i style={{ width:'22px'
                    ,height:'22px',
                    fontSize:'12px',
                    border:'2px solid white'
                    ,borderRadius:'20px',
                    display:'flex',
                    justifyContent:'center',
                    alignItems:'center',
                    marginLeft:'10px'
                     }} class={success?"fa-solid fa-check":"fa-solid fa-xmark"}></i>
                     
                     <p style={{ margin:'0px',fontWeight:'bold' }}>
                        {success}{error}
                     </p>
              
                </div>
            <div className="loading-bar" style={{
            width: `${(progress / 2)}%`,
            backgroundColor:success?'green':'red',
            height:'4px',
            borderRadius:'10px'
          }}></div>
    
                </div>
        </div>
        )
      }
}

export default Message
